import ACCESS_ENUM from "@/access/accessEnum";
import { getLoginUserUsingGet } from "@/api/userController";
import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * 登录用户信息的store
 */

export const useLoginUserStore = defineStore("loginUser", () => {
  const loginUser = ref<API.LoginUserVO>({
    userName: "未登录",
  });

  //set 方法
  function setLogeinUser(newLoginUser: API.LoginUserVO) {
    loginUser.value = newLoginUser;
  }

  async function fetchLoginUser() {
    const res = await getLoginUserUsingGet();
    if (res.data.code === 0 && res.data.data) {
      loginUser.value = res.data.data;
    } else {
      loginUser.value = {
        userRole: ACCESS_ENUM.NOT_LOGIN,
      };
    }
  }

  //  新增：重置用户信息的方法
  function reset() {
    loginUser.value = {
      userName: "未登录",
    };
  }

  return { loginUser, fetchLoginUser, setLogeinUser, reset };
});
